import React from 'react';
import { BubbleProps, Time } from 'react-native-gifted-chat';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { getChatMessageBorderColor } from './constants';
import { Message } from './types';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

type Props = BubbleProps<Message> & {
  buttonText: string;
  onPress: () => void;
  title: string;
};

export const ChatActionMessage: React.FC<Props> = ({
  buttonText,
  onPress,
  title,
  ...rest
}) => {
  const [styles] = useStyles();

  const currentMessage = rest.currentMessage as Message;
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Text style={[TYPOGRAPHY.pSemiBold, styles.headerText]}>{title}</Text>
        <Time
          {...rest}
          containerStyle={{
            left: styles.timeContainer,
            right: styles.timeContainer,
          }}
          timeTextStyle={{
            left: [TYPOGRAPHY.tiny, styles.timeText],
            right: [TYPOGRAPHY.tiny, styles.timeText],
          }}
        />
      </View>
      {currentMessage.text ? (
        <View style={styles.content}>
          <Text style={TYPOGRAPHY.p}>{currentMessage.text}</Text>
        </View>
      ) : null}
      <View style={styles.footer}>
        <TouchableOpacity onPress={onPress} style={styles.footerButton}>
          <Text style={[TYPOGRAPHY.small, FONTS.primarySemiBold]}>
            {buttonText}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.white,
    borderColor: getChatMessageBorderColor(theme),
    borderRadius: 16,
    borderWidth: StyleSheet.hairlineWidth,
  },
  content: {
    minHeight: 20,
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  footer: {
    borderTopColor: getChatMessageBorderColor(theme),
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  footerButton: {
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 14,
  },
  header: {
    alignItems: 'center',
    backgroundColor: theme.colors.primary,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 12,
  },
  headerText: {
    color: theme.colors.white,
    marginLeft: 8,
    overflow: 'hidden',
  },
  timeContainer: {
    marginBottom: 0,
    marginLeft: 8,
    marginRight: 0,
    marginTop: 0,
  },
  timeText: {
    color: theme.colors.white,
    lineHeight: 12,
  },
}));
